<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-12-11 18:06:02
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-12-23 16:37:45
 * @FilePath: \vue-new-hepha\src\views\Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="container">
        <div class="bg"></div>

        <!-- <div class="setLang">
            <div class="earthIcon">
                <img  src="@/assets/image/earth.png" alt="" width="25" height="25">
            </div>
            <a-select 
                class="setLangSelect"
                v-model:value="lang" 
                :bordered="false"
                @change="(val,opt)=>changeSelect(val,opt)"
            >
                <a-select-option value="en">English</a-select-option>
                <a-select-option value="de">Deutsch</a-select-option>
            </a-select>
        </div> -->

        <div class="content" >
            <div class="logo">
                <img src="@/assets/image/logo_large.svg" alt="" width="280">
            </div>

            <div class="descBlock" v-if="!showResetSuccess">
                <div class="desc">{{ $t('login.resetPassword') }}</div>
                <div class="subDesc">{{ $t('login.resetSubDesc') }}</div>
            </div>

            <div class="form" v-if="!showResetSuccess">
                <!-- 邮箱输入 -->
                <div class="form_dialog" v-if="showPrevPage">
                    <img v-if="showBackLogin" class="back" src="@/assets/image/back_icon.png" alt="" @click="backLogin">
                    <div class="form_item">
                        <div class="label">{{ $t('login.email_address') }} <span class="required">*</span></div>
                        <a-input v-model:value="form.email" />
                    </div>
                    <div class="formFooter">
                        <a-button class="loginBtn" type="primary" @click="send">{{ $t('login.send') }}</a-button>
                    </div>
                </div>

                <!-- 验证码输入 -->
                <div class="form_dialog" v-if="!showPrevPage">
                    <img class="back" src="@/assets/image/back_icon.png" alt="" @click="prevPage">
                    <div class="form_item">
                        <div class="label">{{ $t('login.verificationCode') }} <span class="required">*</span></div>
                        <a-input v-model:value="form.verification_code" />
                    </div>
                    <div class="form_item">
                        <div class="label">{{ $t('login.newPassword') }} <span class="required">*</span></div>
                        <a-input-password v-model:value="form.new_password" :maxlength="16"/>
                    </div>
                    <div class="form_item">
                        <div class="label">{{ $t('login.reEnterPassword') }} <span class="required">*</span></div>
                        <a-input-password v-model:value="form.reEnter_password" :maxlength="16"/>
                    </div>
                    <div class="formFooter">
                        <a-button class="loginBtn" type="primary" @click="checkVaildCode">{{ $t('login.reset') }}</a-button>
                    </div>
                </div>
            </div>

            <!-- 重置成功 -->
            <div style="margin-top: 50px;" v-if="showResetSuccess">
                <CheckCircleOutlined style="color: #366fd9; font-size: 30px;margin: -6px 10px 0 0; vertical-align: middle;"/>
                <span style="display: inline-block; margin-top: 5px; font-size: 20px; font-weight: bold;">{{ $t('login.passwordResetSuccessful') }}</span> 
                <div style="margin: 10px 0 0 40px; font-size: 20px;">{{ $t('login.pleaseTryLoginAgain') }}</div>
            </div>
        </div>

        
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch} from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { LoginApi } from '@/api/LoginApi.js';
    import { GlobalOutlined } from '@ant-design/icons-vue';
    import { useStore } from '@/store/index.js';

    const store = useStore()
    const i18n = useI18n()
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()

    const lang = !localStorage.getItem('app_console_lang')? ref('en') : ref(localStorage.getItem('app_console_lang'))
    const form = reactive({
        email:'',
        verification_code:'',
        new_password:'',
        reEnter_password:'',
    })
    const showPrevPage = ref(true)
    const showBackLogin = ref(true)
    const showResetSuccess = ref(false)

    // 切换语言
    const changeSelect = (val)=>{
        localStorage.setItem('app_console_lang', val)
        i18n.locale.value = val
        store.changeLang(val)
    }

    // 返回登录页
    const backLogin = ()=>{
        router.push('/Login')
    }

    // 返回上一页
    const prevPage = ()=>{
        showPrevPage.value = true
    }

    // 发送验证码
    const send = async()=>{
        if(form.email == ''){
            message.error(t('login.email_address') +' '+ t('base.noEmpty'))
            return
        }
        let res = await LoginApi.getInstance().getValidCode(form.email)
        if(res.code == 0){
            form.verification_code = ''
            form.new_password = ''
            form.reEnter_password = ''

            showPrevPage.value = false
            sessionStorage.setItem('token',res.access_token)
            message.success(t('base.sendSucceeded'))
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 校验验证码
    const checkVaildCode = async()=>{
        // let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,10}$/
        let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,16}$/
        if(form.verification_code == ''){
            message.error(t('login.verificationCode') +' '+ t('base.noEmpty'))
            return
        }else if(form.new_password == ''){
            message.error(t('login.newPassword') +' '+ t('base.noEmpty'))
            return
        }else if(!reg.test(form.new_password)){
            message.error({
                content: t('login.passwordFormat'),
                duration: 3,
            })
            return
        }else if(form.reEnter_password == ''){
            message.error(t('login.reEnterPassword') +' '+ t('base.noEmpty'))
            return
        }else if(form.new_password != form.reEnter_password){
            message.error(t('login.confirmPasswordFormat'))
            return
        }
        
        let res = await LoginApi.getInstance().checkVaildCode(form.verification_code)
        if(res.code == 0){
            sessionStorage.setItem('token',res.access_token)
            resetPwd()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 重置密码
    const resetPwd = async()=>{
        let param = {
            new_password: form.new_password,
        }
        let res = await LoginApi.getInstance().resetPwd(param)
        if(res.code == 0){
            showPrevPage.value = false

            if(window.location.href.includes('reset')){
                showResetSuccess.value = true
            }else{
                Modal.success({
                    title: t('base.tip'),
                    content: t('login.resetSucceeded'),
                    okText:t('base.ok'),
                    onOk() {
                        router.push('/Login')
                    },
                });
            }
        }else{
            message.error(res.msg || res.message)
        }
    }

    onMounted(()=>{
        // 获取页面url
        console.log(window.location.href,'href')
        if(window.location.href.includes('reset')){
            showBackLogin.value = false
        }
    })

    
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .container{
    height: 100%;
    overflow-y: scroll;
    background: linear-gradient(-45deg, #f7f6f9 0%, #f7f6f9 50%, #c4dafd 100%);


    .content{
        position: absolute;
        // top: 50%;
        left: 50%;
        z-index: 1;
        // margin-top: -300px;
        margin-left: -300px;
        padding:100px 0 50px;

        .logo{
            margin: 10px auto 50px;
            width: 100%;
            text-align: center;
        }

        .descBlock{
            margin-bottom: 50px;
            width: 100%;
            text-align: center;

            .desc{
                font-weight: 500;
                font-size: 19px;
            }

            .subDesc{
                margin-top: 10px;
                font-size: 17px;
                color: #333;
            }
        }
    }

    // 表单
    .form{
        padding: 30px;
        width: 600px;
        border-radius: 5px;
        background: #fff;
        box-shadow: 1px 1px 18px -12px #000;

        .back{
            margin-bottom: 10px;
            cursor: pointer;
        }

        .form_item{
            margin: 0 0 20px 0;
            .label{
                margin-bottom: 3px;
                font-size: 15px;
                font-weight: bold;
            }
            .required{
                color: red;
            }
        }

        .formFooter{
            text-align: center;

            .loginBtn{
                margin: 20px 20px 15px 20px;
                width: 170px;
                height: 40px;
                outline: none;
            }

            .forgotPassword{
                margin: 0 0 10px 0;
                font-size: 13px;
                cursor: pointer;
            }
            .createAccount{
                font-size: 13px;
                cursor: pointer;
            }
            .forgotPassword:hover,
            .createAccount:hover{
                text-decoration: underline;
                color: #1226aa;
            }
        }
    }
}



::v-deep button:hover {
    border-color: transparent;
}

.setLang{
        position: fixed;
        top: 10px;

        .earthIcon{
            position: fixed;
            right: 170px;
            padding-left: 5px;
            width: 30px;
            height: 32px;
            background: #1226aa;
            img{
                display: inline-block;
                margin-top: 3px;
            }
        }

        .setLangSelect{
            position: fixed;
            // top: 30px;
            right: 50px;
            width: 120px;
            background: #1226aa;
            color:#fff;
        }
}

::v-deep .ant-select-single .ant-select-selector,
::v-deep .ant-select .ant-select-arrow,
::v-deep .ant-select-single.ant-select-open .ant-select-selection-item{
    color:#fff;
}

::v-deep .ant-input{
    height: 40px;
}

::v-deep .ant-input-affix-wrapper >input.ant-input{
    height: 30px;
}
 
}



@media (max-width: 768px) {
    .container{
        height: 100%;
        overflow-y: scroll;
        background: linear-gradient(-45deg, #f7f6f9 0%, #f7f6f9 50%, #c4dafd 100%);

        .content{
            position: absolute;
            z-index: 1;
            padding:40px 20px 50px;
            width: 100%;


            .logo{
                margin: 10px auto 30px;
                text-align: center;

                img{
                    width: 150px !important;
                }
            }

            .descBlock{
                margin-bottom: 20px;
                width: 100%;
                text-align: center;

                .desc{
                    font-weight: 500;
                    font-size: 16px;
                }

                .subDesc{
                    margin-top: 10px;
                    font-size: 15px;
                    color: #333;
                }
            }


            .form{
                padding: 20px;
                border-radius: 5px;
                background: #fff;
                box-shadow: 1px 1px 18px -12px #000;

                .back{
                    margin-bottom: 10px;
                    cursor: pointer;
                }

                .form_item{
                    margin: 0 0 20px 0;
                    .label{
                        margin-bottom: 3px;
                        font-size: 15px;
                        font-weight: bold;
                    }
                    .required{
                        color: red;
                    }
                }

                .formFooter{
                    text-align: center;

                    .loginBtn{
                        margin: 0px 20px 10px 20px;
                        width: 150px;
                        height: 30px;
                        outline: none;
                    }

                    .forgotPassword{
                        margin: 0 0 10px 0;
                        font-size: 13px;
                        cursor: pointer;
                    }
                    .createAccount{
                        font-size: 13px;
                        cursor: pointer;
                    }
                    .forgotPassword:hover,
                    .createAccount:hover{
                        text-decoration: underline;
                        color: #1226aa;
                    }
                }
            }
        }
    }
}
</style>